import React from 'react';
import { FormCombo } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { FormNumber, FormSelect } from '~/components/FormControl';
import PropTypes from 'prop-types';

function ConnectStatusDetail({ statuses, playerStatuses, opponentStatuses }) {
    return (
        <>
            {statuses.length > 0 && (
                <>
                    <StatusFormGroup
                        name={playerStatuses}
                        title="Player Status"
                        headerClass="bg-info"
                        options={statuses || []}
                        tooltip="Statuses given to player. Stacks to let effects take for turns."
                    />
                    <StatusFormGroup
                        name={opponentStatuses}
                        title="Opponent Status"
                        headerClass="bg-warning"
                        options={statuses || []}
                        tooltip="Statuses given to opponent. Stacks to let effects take for turns."
                    />
                </>
            )}
        </>
    );
}
ConnectStatusDetail.defaultProps = {
    statuses: [],
    playerStatuses: 'statusDetail.playerStatuses',
    opponentStatuses: 'statusDetail.opponentStatuses',
};
ConnectStatusDetail.propTypes = {
    statuses: PropTypes.array,
    playerStatuses: PropTypes.string,
    opponentStatuses: PropTypes.string,
};

const withFormCombo = (FormCombo) => {
    // eslint-disable-next-line react/prop-types
    const BaseFormCombo = ({ name, title, headerClass, options, tooltip }) => {
        const renderFunc = (index, defaultValue1) => {
            return (
                <Form.Row>
                    <FormSelect
                        name={`${[name]}.${index}.status`}
                        options={options}
                        sm={6}
                        defaultValue={defaultValue1}
                        label="Name"
                    />
                    <FormNumber
                        name={`${[name]}.${index}.statusVal`}
                        label={'Value'}
                        sm={6}
                    />
                </Form.Row>
            );
        };

        return (
            <FormCombo
                sm={4}
                name={name}
                title={title}
                headerClass={headerClass}
                renderFunc={renderFunc}
                options={options}
                valueObj={{
                    status: '',
                    statusVal: 0,
                }}
                tooltip={tooltip}
            ></FormCombo>
        );
    };

    return BaseFormCombo;
};

const StatusFormGroup = withFormCombo(FormCombo);

export default ConnectStatusDetail;
